/**
 * AI 가사 초안이 도착했을 때 무엇을 할지 정한다.
 *
 * 🚨 Codex 검수 2026-10-13 P0-2: 초안을 기다리는 동안 학생이 가사를 고칠 수 있는데, 종전엔 응답이 오면
 *    무조건 `setLyrics(draft)` 로 덮어 학생이 쓴 가사가 사라졌다. 요청할 때의 가사와 지금 가사가 다르면
 *    덮지 않고 초안을 따로 보여 준다 — 바꿀지는 학생이 고른다.
 */
export type DraftArrival =
  | { kind: "apply"; lyrics: string }
  | { kind: "offer"; draft: string };

export function onDraftArrival(lyricsAtRequest: string, lyricsNow: string, draft: string): DraftArrival {
  return lyricsNow === lyricsAtRequest ? { kind: "apply", lyrics: draft } : { kind: "offer", draft };
}
